import { MakeEmbedWCCContentBlock } from 'components/content/mixins/embed';
import { DOMHelpers } from 'helpers/dom';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import { WCCContentBlock } from '../block/block';
import { WCCContentBlockConfig } from '../block/block.interfaces';
import './image.scss';

const template = `
<fancybox-image-new params="src: url, caption: url">
    <img class="image-content-block__content" data-bind="attr: { src: url }" />
</fancybox-image-new>`

export interface WCCContentImageBlockConfig extends WCCContentBlockConfig {
    url: SubscribableOrNullableValue<string>
}

const ExtendedWCCContentBlock = [
    MakeEmbedWCCContentBlock()
].reduce((result, mixin) => mixin(result), WCCContentBlock);

export class WCCContentImageBlock extends ExtendedWCCContentBlock {
    url: Subscribable<string | undefined>

    constructor(config: WCCContentImageBlockConfig) {
        super(config);

        this.url = ko.flattenComputed(config.url);        
    }

    protected override getNodes() {
        return DOMHelpers.createBindedNodes(template, { url: this.url });
    }
}